<fstr-link [class.collection-card-link]="!noLink()" cssClasses="link-reset" [button]="link()" [showText]="false" [noLink]="noLink()">
  <article class="collection-card">
    <figure class="collection-card__media">
      <fstr-image
        class="collection-card__media__image"
        [image]="collection().image || undefined"
        [width]="1200"
        [height]="920"
        [mode]="imageMode()"
        [other]="'rcolor=white'"
        [colSpan]="{
          xs: 4,
        }"
      ></fstr-image>

      @if (!noLink()) {
        <span class="collection-card__chip chip chip--primary chip--lg">
          <fstr-icon anchor="line-icon-arrow-right"></fstr-icon>
        </span>
      }
    </figure>

    <header class="mt-md-3 text-center">
      @if (collection().subtitle && !hideSubtitle()) {
        <strong class="fs-body-xs fw-normal text-primary lh-sm d-inline-block w-100">{{ collection().subtitle }}</strong>
      }
      <h3 class="fs-body-sm fw-semi lh-sm">{{ collection().title }}</h3>

      @if (intro()) {
        <p class="fs-body-xs text-balance">{{ intro() }}</p>
      }
    </header>
  </article>
</fstr-link>
